import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { tableCellCentered } from '../../../../assets/js/styles'
import { Btn, CustomModal, InputNumeroInteiro } from '../../../../components'
import { setLoadOrder } from '../../../../services/api/https/deliveries/envio-rota.http'

export default function OrdemCarregamentoModal({ visible, deliveries, onResponse }) {
  const [isLoading, setIsLoading] = useState(false)
  const [entregas, setEntregas] = useState([])

  useEffect(() => {
    isLoading && saveOrdemDeCarregamento()
  }, [isLoading])

  useEffect(() => {
    if (visible && Array.isArray(deliveries) && deliveries.length > 0) {
      console.log(deliveries)

      setEntregas(deliveries)
    }
  }, [visible, deliveries])

  // Events
  const onOrdemCarregamentoChange = (entrega, value) => {
    const index = entregas.findIndex(e => e.associacao_id === entrega.associacao_id)
    if (index !== -1) {
      entregas[index].load_order = value
      setEntregas([...entregas])
    }
  }
  // Helpers
  const saveOrdemDeCarregamento = () => {
    try {
      if (!todasAsEntregasPossuemOrdemDeCarregamento()) {
        onResponse('error', 'Existe entrega sem Ordem de Separação associada')
      } else {
        setLoadOrder(entregas)
          .then(() => onResponse('success', entregas))
          .catch(e => onResponse('error', e))
      }
    } catch (error) {
      onResponse('error', error)
    } finally {
      setIsLoading(false)
    }
  }

  const todasAsEntregasPossuemOrdemDeCarregamento = () => {
    let result = true
    entregas.forEach(e => {
      if (Number.isNaN(e.ordem_carregamento) || Number(e.ordem_carregamento) <= 0) {
        result = false
      }
    })
    return result
  }

  // Render
  return (
    <CustomModal
      isVisible={visible}
      header={'Definição da Ordem de Carregamento'}
      width={800}
      onClose={() => onResponse('close')}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <Btn onClick={() => setIsLoading(true)} isLoading={isLoading}>
            Salvar
          </Btn>
        </div>
        <div className="p-col-12">
          <DataTable
            value={entregas}
            paginator={true}
            rows={5}
            emptyMessage="Não existe entrega associada a este veículo"
          >
            <Column field="identifier" header={'Identificador'} style={tableCellCentered(110)} />
            <Column field="razao_social" header={'Cliente'} />
            <Column field="company_name" header={'Empresa'} style={tableCellCentered()} />
            <Column field="city" header={'Cidade'} style={tableCellCentered(150)} />
            <Column field="district" header={'Bairro'} style={tableCellCentered()} />
            <Column
              header={'Ordem Carregamento'}
              style={tableCellCentered(120)}
              body={entrega => (
                <InputNumeroInteiro
                  onChange={value => onOrdemCarregamentoChange(entrega, value)}
                  value={entrega.load_order}
                  marginTop={0}
                />
              )}
            />
          </DataTable>
        </div>
      </div>
    </CustomModal>
  )
}
